export default __webpack_public_path__ + "static/media/pocket.bfb831e1.webp";